import { ColDef, ICellRendererParams } from 'ag-grid-community';
import {
  createAdministratorNameCol,
  createBadgeCol,
  createCustomCol,
  createDateHasAllTimeCol,
  createDetailButtonColV2,
  createIdCol,
} from '@/src/helpers/agColumnHelper';

export const communityReportListColumn = (
  onDetailClick: (id: number) => void,
): ColDef[] => [
  createIdCol(),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    flex: 1,
    headerName: '신고 접수 일시',
  }),
  createBadgeCol({
    field: 'communityReportType',
    size: 'sm',
    options: [
      { label: '신고 접수', value: 'reception', color: 'lightYellow' },
      { label: '블라인드', value: 'blind', color: 'lightRed' },
      { label: '신고 반려', value: 'common', color: 'lightGray' },
    ],
    headerName: '신고 상태',
  }),
  createBadgeCol({
    field: 'communityType',
    options: [
      { label: '게시글', value: 'posting', color: 'lightBlue' },
      { label: '댓글', value: 'comment', color: 'lightYellow' },
    ],
    size: 'sm',
    headerName: '분류',
  }),
  createCustomCol({
    field: 'communityReportReasonTypeKr',
    size: 'lg',
    flex: 2,
    cellRenderer: ({ value, data }: ICellRendererParams) => {
      return `${value}${data?.communityReportReasonTypeKr === '기타' ? ` (${data?.reportReason})` : ''}`;
    },
    headerName: '신고 사유',
  }),
  createCustomCol({
    field: 'reporterNick',
    size: 'sm',
    cellRenderer: ({ data }: ICellRendererParams) =>
      data?.customer?.nick || '-',
    headerName: '신고자 닉네임',
  }),
  createBadgeCol({
    field: 'communityBlindStatusType',
    options: [
      { label: '처리중', value: 'reception', color: 'lightYellow' },
      { label: '처리 완료', value: 'done', color: 'lightGray' },
    ],
    size: 'sm',
    valueGetter: ({ data }) =>
      data?.communityReportType === 'reception' ? 'reception' : 'done',
    headerName: '처리 상태',
  }),
  createDateHasAllTimeCol({
    field: 'reportHandledAt',
    size: 'md',
    headerName: '처리 일시',
  }),
  createAdministratorNameCol({
    headerName: '처리 담당자',
  }),
  createDetailButtonColV2(onDetailClick, { headerName: '블라인드' }),
];
